import{createUnarySpacing as n}from"../spacing/spacing.js";function t(t=8,r=n({spacing:t})){if(t.mui)return t;const i=(...n)=>(0===n.length?[1]:n).map((n=>{const t=r(n);return"number"==typeof t?`${t}px`:t})).join(" ");return i.mui=!0,i}export{t as default};
//# sourceMappingURL=createSpacing.js.map
